"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = exports.Header = exports.Footer = exports.Content = exports.CloseArea = exports.LockScroll = exports.Inner = exports.Overlay = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const breakpoints_1 = require("../themes/breakpoints");
const colors_1 = require("../themes/colors");
const common_1 = require("../themes/common");
exports.Overlay = styled_components_1.default.div `
  ${({ zIndex }) => (0, styled_components_1.css) `
    position: fixed;
    display: flex;
    backdrop-filter: blur(4px);
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    z-index: 99999;
    top: 0;
    left: 0;

    ${breakpoints_1.media.sm `
    z-index: ${zIndex || 99999};
  `}

    ::after {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      opacity: 0.5;
      background: ${colors_1.colors.black};
    }
  `}
`;
exports.Inner = styled_components_1.default.div `
  ${({ contentHeight, maxWidth, vh }) => (0, styled_components_1.css) `
    box-sizing: border-box;
    background: ${colors_1.colors.shade10};
    max-height: 100vh;
    min-height: 300px;
    max-width: ${maxWidth};
    width: 100%;
    height: ${`${vh}px`};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid ${colors_1.colors.shade50};
    box-shadow: ${common_1.shadows.default};
    position: absolute;

    ${breakpoints_1.media.sm `
			top: 140px;
			height: ${contentHeight};
			max-height: calc(100vh - 280px);
			border-radius: 25px;
		`}
  `}
`;
exports.LockScroll = (0, styled_components_1.createGlobalStyle) `
  html, body {
    overflow-y: ${({ locked }) => (locked ? 'hidden' : 'auto')};
  };
`;
exports.CloseArea = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    position: absolute;
    top: ${theme.spacing.unit * 4}px;
    right: ${theme.spacing.unit * 4}px;
    background: ${colors_1.colors.shade10};

    & > span > svg {
      cursor: pointer;
      color: ${colors_1.colors.primaryBlue100};
    }
  `}
`;
exports.Content = styled_components_1.default.div `
  ${({ theme, noPadding }) => (0, styled_components_1.css) `
    height: 100%;
    padding: ${noPadding ? '0' : `${theme.spacing.unit * 3}px`};
    overflow-y: auto;
  `}
`;
exports.Footer = styled_components_1.default.div `
  ${({ theme, noBorder }) => (0, styled_components_1.css) `
    padding: ${theme.spacing.unit * 3}px;
    position: absolute;
    bottom: 0;
    background: ${colors_1.colors.shade10};
    z-index: 1;
    flex-shrink: 0;
    border-top: ${noBorder
    ? 'none'
    : `${theme.border.style} ${theme.palette.border.secondary}`};
  `}

  ${breakpoints_1.media.sm `
		position: sticky;
	`}
`;
exports.Header = styled_components_1.default.div `
  ${({ theme, noHeader }) => (0, styled_components_1.css) `
    padding: ${noHeader ? 0 : `${theme.spacing.unit * 4}px 0px 0px`};
    position: sticky;
    top: 0;
    flex-shrink: 0;
    background: ${noHeader ? 'transparent' : colors_1.colors.shade10};
    z-index: 1;

    & > * {
      :not(#closer) {
        padding: 0px ${theme.spacing.unit * 4}px;
      }
    }

    & > * + * {
      :not(#closer) {
        padding-top: ${theme.spacing.unit * 3}px;
      }
    }
  `}
`;
exports.Separator = styled_components_1.default.div `
  ${({ theme, noBorder }) => (0, styled_components_1.css) `
    width: 100%;
    height: 1px;
    ${!noBorder &&
    (0, styled_components_1.css) `
      border-bottom: ${theme.border.style} ${theme.palette.border.secondary};
    `}
  `}
`;
//# sourceMappingURL=styled.js.map